import { render, staticRenderFns } from "./balanceDetail.vue?vue&type=template&id=089e4cfd&scoped=true&"
import script from "./balanceDetail.vue?vue&type=script&lang=js&"
export * from "./balanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./balanceDetail.vue?vue&type=style&index=0&id=089e4cfd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e4cfd",
  null
  
)

export default component.exports